<div class=" mt-4">
  <div class="row mb-4">
    <div class="col text-center">
      <h1>{{ 'DASHBOARD.TITLE' | translate }}</h1>
    </div>
  </div>

  <div class="row mb-4">
    @for (widget of widgets | slice:0:4; track widget) {
<div class="col-6 col-sm-3 mb-4">
      <app-homepage-widget
        [title]="widget.title"
        [legend]="widget.legend"
        [data]="widget.data"
        [options]="widget.options"
        [isChart]="widget.isChart"
        [isLoading]="widget.isLoading">
      </app-homepage-widget>
    </div>
}
  </div>

  <div class="row mb-4">
    @for (widget of widgets | slice:4; track widget) {
<div class="col-md-4 col-lg-4 mb-4">
      <app-homepage-widget
        [title]="widget.title"
        [legend]="widget.legend"
        [data]="widget.data"
        [options]="widget.options"
        [isChart]="widget.isChart"
        [isLoading]="widget.isLoading">
      </app-homepage-widget>
    </div>
}
    <div class="col-md-4 col-lg-4 mb-4">
      <app-role-distribution-widget></app-role-distribution-widget>
    </div>
  </div>
  
  <div class="row mb-4">
    <div class="col-md-4 col-lg-6 mb-4">
      <app-skill-distribution-widget></app-skill-distribution-widget>
    </div>
    <div class="col-md-4 col-lg-6 mb-4">
      <app-headcount-widget></app-headcount-widget>
    </div>
  </div>
  <div class="row mb-4">
    <div class="col-md-6 col-lg-6 mb-4"> 
      <app-team-status-widget></app-team-status-widget>
    </div>
    <div class="col-md-6 col-lg-6 mb-4"> 
      <app-open-positions-widget></app-open-positions-widget>
    </div>
  </div>
</div>